import React from 'react';
import { BRAND_LOGO } from '../brand';

/**
 * Claw brand logo component.
 *
 * Props:
 *   variant    — 'icon' (mark only) | 'wordmark' (mark + "CLAW" text) — default 'icon'
 *   size       — icon size in px (default 24)
 *   color      — SVG fill color, any CSS color (default 'white')
 *   shape      — outer container shape: 'none' | 'rounded' | 'circle' | 'square' (default 'none')
 *   bg         — container background: 'brand' for primary→secondary gradient, or any CSS color (default 'brand')
 *   padding    — inner padding in px when shape is set (auto-calculated from size if omitted)
 *   className  — extra classes on the outermost element
 */
const SHAPES = {
  rounded: 'rounded-xl',
  circle:  'rounded-full',
  square:  'rounded-sm',
};

const AppLogo = ({
  variant = 'icon',
  size = 24,
  color = 'white',
  shape = 'none',
  bg = 'brand',
  padding,
  className = '',
}) => {
  const logo = BRAND_LOGO[variant] ?? BRAND_LOGO.icon;
  const pad = padding ?? Math.round(size * 0.3);

  const bgStyle =
    bg === 'brand'
      ? { background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))' }
      : { backgroundColor: bg };

  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={logo.viewBox}
      width={size}
      height={size}
      fill={color}
      aria-label="Claw"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {logo.paths.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );

  if (shape === 'none') return icon;

  return (
    <div
      className={`inline-flex items-center justify-center flex-shrink-0 ${SHAPES[shape] ?? 'rounded-xl'} ${className}`}
      style={{ padding: pad, ...bgStyle }}
    >
      {icon}
    </div>
  );
};

export default AppLogo;
